import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe71baa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "build-cache-configuration--header" }
const _hoisted_2 = { class: "incredi-scroll-bar-narrow" }
const _hoisted_3 = { class: "build-cache-configuration--content" }
const _hoisted_4 = { class: "pl-[16px] pt-[4px]" }
const _hoisted_5 = { class: "pl-[17px] mt-[12px] gap-[24px] w-[296px] flex col" }
const _hoisted_6 = {
  key: 0,
  class: "flex row w-full self-stretch"
}
const _hoisted_7 = { class: "flex flex-nowrap items-baseline w-full" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low text-[12px] w-[32px]" }, "Host", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-Text/text_low text-[12px] w-[32px]" }, "Port", -1))
const _hoisted_10 = {
  key: 2,
  class: "flex flex-col justify-center items-center h-full gap-[8px]"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-gordita-regular text-Text/text_medium text-[12px] text-center" }, " You have no clusters or clusters with nodes. Click \"Manage Clusters\" under \"Build Cache Configuration\" to create your first cluster. ", -1))
const _hoisted_13 = { class: "h-[48px] px-[16px] mb-[16px]" }
const _hoisted_14 = { class: "flex flex-row-reverse content-center h-[40px] pr-[16px]" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Submit ")

import { computed, inject, ref, watch } from 'vue';
import { IncrediField, IncrediButton, IncrediNote, IncrediForm, useIncrediForm, IncrediTooltip, IncrediSelect } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { isNumberInRange } from '@/services/utils';
import { useI18n } from 'vue-i18n';
import IncrediCheckBox from '@/components/inputs/incrediCheckBox.vue';
import elementsIds from '@/const/elementIds.json';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { validateIpAndDns } from '@/utils/string-validations';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import IncrediToggle from '@/components/inputs/incrediToggle.vue';
import NO_CLUSTERS_IMG from '@/assets/images/build-cache-clusters/no_cluster.svg';
import { ClustersQuery, useClustersQuery } from '@/graphql/codegen/generated/graphql';
import { SelectedAgent } from './AgentActionMenu.types';

type Cluster = NonNullable<NonNullable<ClustersQuery['clusters']>[number]> | null;

export default /*#__PURE__*/_defineComponent({
  __name: 'AgentEnableBuildCache',
  props: {
    agents: null
  },
  emits: ["submit", "preventContextClose"],
  setup(__props: any, { emit }: { emit: ({ (e: 'submit', value: object): void; (e: 'preventContextClose', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  agents: SelectedAgent[];
}

const coordinatorsService = inject(IKCoordinatorsService);
const { isAgentOS32Bit } = useAgentsTableUtils();
// eslint-disable-next-line no-unused-vars

const defaultPort = '51100';
const { t } = useI18n();

const isBulk = props.agents?.length > 1;
const disableLocalCacheTooltip = ref(false);
const getPortAndHost = (remoteCacheServer: string = '') => {
  const host = remoteCacheServer?.split(':')[0];
  const port = remoteCacheServer?.split(':')[1];
  return { host, port };
};

const GQL_useClusters = useClustersQuery({ filter: { hasNodes: true } }, { fetchPolicy: 'network-only' });
const clusterList = computed(() => GQL_useClusters?.result?.value?.clusters || []);
const formInitialValues = computed(() => {
  const initialValues = {
    allocateBuildCacheCheckbox: false as boolean | null,
    useLocalCacheCheckbox: false as boolean | null,
    useSharedCacheCheckbox: false as boolean | null,
    sharedCacheHost: '',
    sharedCachePort: '',
    selectedCluster: null as Cluster,
    useCluster: true,
  };
  if (isBulk) {
    initialValues.allocateBuildCacheCheckbox = props.agents.every((value, index, array) => array[0].license?.buildCacheAllowed === value?.license?.buildCacheAllowed)
      ? props.agents[0]?.license?.buildCacheAllowed || false
      : false;
    initialValues.useLocalCacheCheckbox = props.agents.every((value, index, array) => array[0].buildCacheSettings?.useLocalCache === value?.buildCacheSettings?.useLocalCache)
      ? props.agents[0].buildCacheSettings?.useLocalCache || false
      : false;
    initialValues.useSharedCacheCheckbox = props.agents.every((value, index, array) => array[0].buildCacheSettings?.remoteCacheServer === value.buildCacheSettings?.remoteCacheServer)
      ? !!props.agents[0].buildCacheSettings?.remoteCacheServer || false
      : false;
    initialValues.sharedCacheHost = props.agents.every(
      (value, index, array) =>
        !!getPortAndHost(array[0].buildCacheSettings?.remoteCacheServer || '').host &&
        getPortAndHost(array[0].buildCacheSettings?.remoteCacheServer || '').host === getPortAndHost(value.buildCacheSettings?.remoteCacheServer || '').host,
    )
      ? getPortAndHost(props.agents[0].buildCacheSettings?.remoteCacheServer || '').host
      : '';
    initialValues.sharedCachePort = props.agents.every(
      (value, index, array) =>
        !!getPortAndHost(array[0].buildCacheSettings?.remoteCacheServer || '').port &&
        getPortAndHost(array[0].buildCacheSettings?.remoteCacheServer || '').port === getPortAndHost(value.buildCacheSettings?.remoteCacheServer || '').port,
    )
      ? getPortAndHost(props.agents[0].buildCacheSettings?.remoteCacheServer || '').port
      : '';
    initialValues.useCluster = props.agents.every((value, index, array) => array[0].buildCacheSettings?.useBuildCacheCluster === value.buildCacheSettings?.useBuildCacheCluster)
      ? !!props.agents[0].buildCacheSettings?.useBuildCacheCluster
      : false;
  } else {
    initialValues.allocateBuildCacheCheckbox = props.agents[0].license?.buildCacheAllowed || false;
    initialValues.useLocalCacheCheckbox = props.agents[0].buildCacheSettings?.useLocalCache || false;
    initialValues.useSharedCacheCheckbox = !!props.agents[0].buildCacheSettings?.remoteCacheServer;
    const { host, port } = getPortAndHost(props.agents[0]?.buildCacheSettings?.remoteCacheServer || '');
    initialValues.sharedCacheHost = initialValues.useSharedCacheCheckbox && !props.agents[0].buildCacheSettings?.useBuildCacheCluster ? host || '' : '';
    initialValues.sharedCachePort = initialValues.useSharedCacheCheckbox && !props.agents[0].buildCacheSettings?.useBuildCacheCluster ? port || '' : '';
    initialValues.useCluster = !!props.agents[0].buildCacheSettings?.useBuildCacheCluster || !initialValues.useSharedCacheCheckbox;
    initialValues.selectedCluster =
      (!!props.agents[0].buildCacheSettings?.useBuildCacheCluster && clusterList.value.find(cluster => cluster?.name === props.agents[0]?.buildCacheSettings?.remoteCacheServer)) || null;
  }

  return initialValues;
});

const { form, fields } = useIncrediForm({
  initialValues: formInitialValues.value,
  validationSchema: {
    sharedCacheHost: [
      (v: string) => {
        if (!fields.useSharedCacheCheckbox.value.value || fields.useCluster.value.value) {
          return true;
        }
        return (v && v.length > 0 && validateIpAndDns(v)) || t('agentsTable.agentBuildCacheConfiguration.validationRules.host');
      },
    ],
    sharedCachePort: [
      (v: number) => {
        if (!fields.useSharedCacheCheckbox.value.value || fields.useCluster.value.value) {
          return true;
        }
        return (v && isNumberInRange(1024, 65535, v)) || t('agentsTable.agentBuildCacheConfiguration.validationRules.port');
      },
    ],
  },
});

const sortedClusterList = computed(() =>
  [...clusterList.value].sort((clusterA, clusterB) => {
    if (clusterA?.id === -1 || clusterB?.id === -1) {
      return clusterA?.id === -1 ? -1 : 1;
    }
    if (clusterA?.name === fields.selectedCluster.value.value?.name || clusterB?.name === fields.selectedCluster.value.value?.name) {
      return clusterA?.name === fields.selectedCluster.value.value?.name ? -1 : 1;
    }
    return clusterA?.name.localeCompare(clusterB?.name || '', 'en', { sensitivity: 'base' }) || 0;
  }),
);

watch(
  () => clusterList.value,
  () => {
    fields.selectedCluster.value.value = (fields.useCluster && clusterList.value.find(cluster => cluster?.name === props.agents[0]?.buildCacheSettings?.remoteCacheServer)) || null;
  },
);

const showNoteMessage = computed(() => {
  if (!fields.allocateBuildCacheCheckbox.value.value) {
    return false;
  }
  return fields.useLocalCacheCheckbox.value.value || fields.useSharedCacheCheckbox.value.value;
});

const disableSharedCache = () => {
  form.setErrors({
    sharedCacheHost: '',
    sharedCachePort: '',
  });
};

const disableLocalCache = () => {
  form.setErrors({
    useLocalCacheCheckbox: '',
  });
};

const disableCache = () => {
  disableSharedCache();
  disableLocalCache();
};

const sharedCacheDisabled = computed(() => !fields.allocateBuildCacheCheckbox.value.value || !fields.useSharedCacheCheckbox.value.value);

const shouldDisableLocalCache = computed(
  () =>
    (!!fields.allocateBuildCacheCheckbox.value.value && props.agents.every(agent => isAgentOS32Bit(agent))) ||
    props.agents.some(agent => clusterList.value?.find(cluster => cluster?.nodes?.find(node => node?.agentId === agent.id))),
);

const submitForm = async () => {
  await form.validate();
  if (form.meta.value.valid) {
    emit(
      'submit',
      props.agents.map(agent => {
        const agentId = agent?.id as string;

        const setRemoteCacheServer = () => {
          // indeterminate value
          if (form.values.useSharedCacheCheckbox === null) {
            if (form.values.useCluster) {
              return form.values.selectedCluster?.name || '';
            }
            const { host, port } = getPortAndHost(agent?.buildCacheSettings?.remoteCacheServer || '');
            const payloadHost = form.values.sharedCacheHost ? form.values.sharedCacheHost : host;
            const payloadPort = form.values.sharedCachePort ? form.values.sharedCachePort : port;
            return payloadHost && payloadPort ? `${payloadHost}:${payloadPort}` : '';
          }

          if (form.values.useSharedCacheCheckbox) {
            return !form.values.useCluster ? `${form.values.sharedCacheHost}:${form.values.sharedCachePort}` : form.values.selectedCluster?.name || '';
          }
          return '';
        };

        return {
          agentId,
          coordinatorId: coordinatorsService?.selectedCoordinator.value || '',
          allocateBuildCache: form.values.allocateBuildCacheCheckbox,
          useLocalCache: fields.useLocalCacheCheckbox.value.value === null ? agent?.buildCacheSettings?.useLocalCache : form.values.useLocalCacheCheckbox,
          useBuildCacheCluster: fields.useCluster.value.value && fields.useSharedCacheCheckbox.value.value,
          remoteCacheServer: setRemoteCacheServer(),
        };
      }),
    );
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediForm), {
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('agentsTable.agentBuildCacheConfiguration.title')), 1),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(IncrediCheckBox, {
                  modelValue: _unref(fields).allocateBuildCacheCheckbox.value.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(fields).allocateBuildCacheCheckbox.value.value) = $event)),
                  "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.allocateBuildCache,
                  class: "flex text-[12px] h-[32px]",
                  "label-for": "checkbox-allocate-cache",
                  label: _ctx.$t('agentsTable.agentBuildCacheConfiguration.allowCache'),
                  value: _unref(fields).allocateBuildCacheCheckbox.value.value,
                  onInput: _cache[1] || (_cache[1] = (e) => {
                _unref(fields).allocateBuildCacheCheckbox.value.value = e;
                if(!e) {
                  disableCache();
                }
              })
                }, null, 8, ["modelValue", "data-testid", "label", "value"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(IncrediTooltip), {
                    "model-value": disableLocalCacheTooltip.value && _unref(shouldDisableLocalCache),
                    direction: "middle-right",
                    "offset-x": -150,
                    hover: "",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = (value)=>disableLocalCacheTooltip.value = value)
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(shouldDisableLocalCache) ? _ctx.$t('agentsTable.agentBuildCacheConfiguration.localCacheDisabledCluster') : _ctx.$t('agentsTable.agentBuildCacheConfiguration.localCacheDisabled32Bit')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(IncrediCheckBox, {
                        "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.localCacheCheckbox,
                        class: "flex text-[12px] h-[32px]",
                        "label-for": "checkbox-local-cache",
                        disable: !_unref(fields).allocateBuildCacheCheckbox.value.value || _unref(shouldDisableLocalCache),
                        label: _ctx.$t('agentsTable.agentBuildCacheConfiguration.localCache'),
                        value: _unref(fields).useLocalCacheCheckbox.value.value,
                        onInput: _cache[2] || (_cache[2] = (v) => {
                _unref(fields).useLocalCacheCheckbox.value.value = v;
              })
                      }, null, 8, ["data-testid", "disable", "label", "value"])
                    ]),
                    _: 1
                  }, 8, ["model-value"]),
                  _createVNode(IncrediCheckBox, {
                    "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.sharedCacheCheckbox,
                    class: "flex text-[12px] h-[32px]",
                    "label-for": "checkbox-local-cache",
                    label: _ctx.$t('agentsTable.agentBuildCacheConfiguration.sharedCache'),
                    disable: !_unref(fields).allocateBuildCacheCheckbox.value.value,
                    "model-value": _unref(fields).useSharedCacheCheckbox.value.value,
                    value: _unref(fields).useSharedCacheCheckbox.value.value,
                    onInput: _cache[4] || (_cache[4] = (e) => {
                _unref(fields).useSharedCacheCheckbox.value.value = e;
                if(!e) {
                  disableSharedCache();
                } else {
                  _unref(fields).sharedCachePort.value.value = _unref(fields).sharedCachePort.value.value ? _unref(fields).sharedCachePort.value.value : !isBulk ? defaultPort : '';
                }
              })
                  }, null, 8, ["data-testid", "label", "disable", "model-value", "value"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(IncrediToggle, {
                    modelValue: _unref(fields).useCluster.value.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(fields).useCluster.value.value) = $event)),
                    class: "w-full",
                    grow: true,
                    disabled: _unref(sharedCacheDisabled),
                    "default-toggle-value": _unref(fields).useCluster.value.value,
                    "toggle-on-text": "Cluster",
                    "toggle-off-text": "Single Endpoint",
                    onInput: _cache[6] || (_cache[6] = (e) => {
                  if (!e) {
                    _unref(fields).sharedCachePort.value.value = _unref(fields).sharedCachePort.value.value ? _unref(fields).sharedCachePort.value.value : !isBulk ? defaultPort : '';
                  }
                })
                  }, null, 8, ["modelValue", "disabled", "default-toggle-value"]),
                  (!_unref(fields).useCluster.value.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_unref(IncrediField), {
                            modelValue: _unref(fields).sharedCacheHost.value.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(fields).sharedCacheHost.value.value) = $event)),
                            "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.host,
                            class: "pl-[8px] w-full",
                            label: isBulk && _unref(fields).useSharedCacheCheckbox.value.value === null ? _ctx.$t('agentsTable.agentBuildCacheConfiguration.multipleLabel') : '',
                            disabled: _unref(sharedCacheDisabled),
                            error: !!_unref(form).errors.value.sharedCacheHost,
                            "error-message": _unref(form).errors.value.sharedCacheHost || '',
                            maxlength: 255,
                            size: "tiny",
                            onChange: _cache[8] || (_cache[8] = () => _unref(fields).sharedCacheHost.validate())
                          }, null, 8, ["modelValue", "data-testid", "label", "disabled", "error", "error-message"])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass([!!_unref(form).errors.value.sharedCacheHost ? 'mt-[14px]' : 'mt-[32px]', "flex flex-nowrap items-baseline w-full"])
                        }, [
                          _hoisted_9,
                          _createVNode(_unref(IncrediField), {
                            modelValue: _unref(fields).sharedCachePort.value.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(fields).sharedCachePort.value.value) = $event)),
                            "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.port,
                            class: "pl-[8px] w-full",
                            type: "number",
                            label: isBulk && _unref(fields).useSharedCacheCheckbox.value.value === null ? _ctx.$t('agentsTable.agentBuildCacheConfiguration.multipleLabel') : '',
                            disabled: _unref(sharedCacheDisabled),
                            error: !!_unref(form).errors.value.sharedCachePort,
                            "error-message": _unref(form).errors.value.sharedCachePort || '',
                            maxlength: 20,
                            size: "tiny",
                            onChange: _cache[10] || (_cache[10] = () => _unref(fields).sharedCachePort.validate())
                          }, null, 8, ["modelValue", "data-testid", "label", "disabled", "error", "error-message"])
                        ], 2)
                      ]))
                    : (_unref(sortedClusterList).length)
                      ? (_openBlock(), _createBlock(_unref(IncrediSelect), {
                          key: 1,
                          disabled: _unref(sharedCacheDisabled),
                          items: _unref(sortedClusterList) as any,
                          class: "w-[278px]",
                          size: "tiny",
                          "value-field": "name",
                          "key-field": "id",
                          "list-max-height": 232,
                          "model-value": _unref(fields).selectedCluster.value.value,
                          "is-searchable": "",
                          label: "Select a cluster",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = (value) => _unref(fields).selectedCluster.value.value = value),
                          onMenuVisibility: _cache[12] || (_cache[12] = ($event: any) => (emit('preventContextClose', $event)))
                        }, null, 8, ["disabled", "items", "model-value"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("img", {
                            class: "w-[68px]",
                            src: _unref(NO_CLUSTERS_IMG)
                          }, null, 8, _hoisted_11),
                          _hoisted_12
                        ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_unref(showNoteMessage))
                  ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                      key: 0,
                      "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.note,
                      type: "Information"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(fields).useLocalCacheCheckbox.value.value ? _ctx.$t('agentsTable.agentBuildCacheConfiguration.agentsLocalCacheNote') : _ctx.$t('agentsTable.agentBuildCacheConfiguration.agentsSharedCacheNote')), 1)
                      ]),
                      _: 1
                    }, 8, ["data-testid"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(IncrediButton), {
                "data-testid": _unref(elementsIds).agents.contextMenu.buildCacheSettings.saveButton,
                disabled: !_unref(form).meta.value.dirty || (_unref(fields).useCluster.value.value && !_unref(fields).selectedCluster.value.value && !_unref(sharedCacheDisabled)),
                design: "primary-green",
                size: "tiny",
                onKeydown: _withKeys(_withModifiers(submitForm, ["prevent"]), ["enter"])
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["data-testid", "disabled", "onKeydown"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }))
}
}

})